/**
 * Payment Account Filter Configuration
 *
 * Configuration for PaymentAccountFilters component using GenericFilters.
 * Eliminates 290 lines of duplicated filter code.
 */

import type { FilterConfig } from '@/types/filter';
import type { PaymentAccountFilters } from '@/types/payment-account';
import {
  PaymentAccountType,
  PaymentAccountStatus,
  formatPaymentAccountType,
  formatPaymentAccountStatus,
} from '@/types/payment-account';

const popularBanks = [
  'Banco do Brasil',
  'Bradesco',
  'Itaú',
  'Santander',
  'Caixa',
  'Nubank',
  'Inter',
  'C6 Bank',
  'BTG Pactual',
  'PicPay',
];

export const paymentAccountFilterConfig: FilterConfig<PaymentAccountFilters> = {
  fields: [
    {
      key: 'type',
      type: 'select',
      label: 'Tipo',
      placeholder: 'Todos os tipos',
      options: Object.values(PaymentAccountType).map((type) => ({
        value: type,
        label: formatPaymentAccountType(type),
      })),
    },
    {
      key: 'status',
      type: 'select',
      label: 'Status',
      placeholder: 'Todos os status',
      options: Object.values(PaymentAccountStatus).map((status) => ({
        value: status,
        label: formatPaymentAccountStatus(status),
      })),
    },
    {
      key: 'bank_name',
      type: 'select',
      label: 'Banco',
      placeholder: 'Todos os bancos',
      options: popularBanks.map((bank) => ({
        value: bank,
        label: bank,
      })),
    },
  ],
  sortFields: [
    { key: 'name', label: 'Nome' },
    { key: 'type', label: 'Tipo' },
    { key: 'current_balance', label: 'Saldo' },
    { key: 'created_at', label: 'Data de criação' },
    { key: 'transaction_count', label: 'Mais usadas' },
  ],
  defaultSortBy: 'name',
  defaultSortOrder: 'asc',
  gridColumns: 5,
  formatFilterValue: (key, value) => {
    if (key === 'type') {
      return formatPaymentAccountType(value as PaymentAccountType);
    }
    if (key === 'status') {
      return formatPaymentAccountStatus(value as PaymentAccountStatus);
    }
    return String(value);
  },
};
